import { EnvironmentProviders, Provider } from '@angular/core';

import { iconFileNamePathsObject } from '../../shared/icon-name-paths';
import { SVG_ICON_CONFIG, SvgIconConfig } from './svg-icon-config.token';

/**
 * Provides the SvgIconService with configuration.
 *
 * @param config Optional configuration for the SvgIconService. If not provided, default values will be used.
 * @returns An array of providers that includes the SvgIconService configuration
 */
export function provideSvgIcon(config?: Partial<SvgIconConfig>): Provider | EnvironmentProviders[] {
    return [
        {
            provide: SVG_ICON_CONFIG,
            useValue: {
                iconAssetPath: config?.iconAssetPath ?? '/assets/svg-icons/',
                iconFileNamesObject: config?.iconFileNamesObject ?? iconFileNamePathsObject,
                useIonIconComponent: config?.useIonIconComponent ?? true
            }
        }
    ];
}
